import React from 'react';
import { Toaster as SonnerToaster } from 'sonner';

const Toaster = () => {
  return (
    <SonnerToaster
      position="top-right"
      toastOptions={{
        style: {
          background: '#FFFFFF',
          border: '1px solid #E2E8F0',
          color: '#1E293B',
        },
      }}
    />
  );
};

export default Toaster;
